var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxBxsUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65726 1.37855C4.69549 1.3371 4.74663 1.30321 4.8063 1.27979C4.86596 1.25638 4.93236 1.24414 4.99976 1.24414C5.06716 1.24414 5.13356 1.25638 5.19322 1.27979C5.25289 1.30321 5.30404 1.3371 5.34226 1.37855L9.09226 5.423C9.13567 5.46965 9.16112 5.52429 9.16586 5.58098C9.1706 5.63767 9.15443 5.69425 9.11913 5.74457C9.08383 5.79488 9.03073 5.83701 8.96561 5.86638C8.90049 5.89574 8.82584 5.91122 8.74976 5.91113H1.24976C1.17386 5.9109 1.09948 5.89522 1.03463 5.86578C0.96977 5.83635 0.916886 5.79427 0.881664 5.74407C0.846441 5.69387 0.830212 5.63745 0.834722 5.58088C0.839232 5.52431 0.86431 5.46972 0.90726 5.423L4.65726 1.37855Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxsUpArrow);
export default __webpack_public_path__ + "static/media/bx_bxs-up-arrow.cd08e8e7f532f3ef7c68d615d9b7a5ec.svg";
export { ForwardRef as ReactComponent };